import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth, landingPath } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2, Store, ShieldCheck } from "lucide-react";

export default function Login() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("admin123");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user) navigate(landingPath(user.role));
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    const res = await login(email.trim(), password);
    setLoading(false);
    if (res.ok) navigate(landingPath(res.user.role));
    else setErr(res.error);
  };

  return (
    <div className="flex min-h-screen">
      <div className="hidden w-1/2 flex-col justify-between bg-slate-900 p-12 text-white lg:flex">
        <div className="flex items-center gap-3">
          <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-primary font-heading text-2xl font-extrabold">K</div>
          <div className="font-heading text-2xl font-extrabold tracking-tight">TOKO KU</div>
        </div>
        <div>
          <h1 className="font-heading text-4xl font-bold leading-tight tracking-tight sm:text-5xl">
            Kelola 5+ cabang toko kelontong dalam satu sistem.
          </h1>
          <p className="mt-5 max-w-md text-slate-400">
            POS, stok real-time, pembelian, HPP rata-rata tertimbang, shift kasir, dan laporan — semua terpusat.
          </p>
          <div className="mt-8 flex gap-6 text-sm">
            <div className="flex items-center gap-2"><ShieldCheck className="h-4 w-4 text-primary" /> RBAC per peran</div>
            <div className="flex items-center gap-2"><Store className="h-4 w-4 text-primary" /> Isolasi per cabang</div>
          </div>
        </div>
        <div className="text-xs text-slate-500">Online-only · Installable PWA · Rupiah (IDR)</div>
      </div>

      <div className="flex w-full items-center justify-center p-6 lg:w-1/2">
        <div className="w-full max-w-sm">
          <div className="mb-8 lg:hidden">
            <div className="flex items-center gap-2">
              <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-primary font-heading text-xl font-extrabold text-white">K</div>
              <div className="font-heading text-xl font-extrabold tracking-tight">TOKO KU</div>
            </div>
          </div>
          <h2 className="font-heading text-2xl font-bold tracking-tight">Masuk ke akun Anda</h2>
          <p className="mt-1 text-sm text-muted-foreground">Gunakan email & kata sandi staf Anda.</p>

          <form onSubmit={submit} className="mt-6 space-y-4">
            <div className="space-y-2">
              <Label htmlFor="email">Email</Label>
              <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)}
                placeholder="nama@tokoku.id" required data-testid="login-email" />
            </div>
            <div className="space-y-2">
              <Label htmlFor="password">Kata Sandi</Label>
              <Input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)}
                required data-testid="login-password" />
            </div>
            {err && <div className="rounded-md bg-destructive/10 px-3 py-2 text-sm text-destructive" data-testid="login-error">{err}</div>}
            <Button type="submit" className="h-11 w-full text-base" disabled={loading} data-testid="login-submit">
              {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Masuk"}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}
